import { Component, OnInit } from '@angular/core';
import { TotemService } from '../totem.service';
import { environment } from 'src/environments/environment.prod';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-informacion',
  templateUrl: './informacion.component.html',
  styleUrls: ['./informacion.component.css'],
  animations: [
    trigger('fadeIn', [
      state('hide', style({opacity: 0})),
      state('show', style({opacity: 1})),
      transition('hide => show', [
        animate('0.3s')
      ])
    ])
  ]
})
export class InformacionComponent implements OnInit {
  informaciones = [];
  listadoSup = [];
  listadoInf = [];
  activePlace: any = 0;
  selectedPlace: any;

  mapType = 'roadmap';
  showMarker = false;
  lastPlaceClicked: any = '';
  center = {lat: 0, lng: 0, zoom: 16};
  marker = {lat: 0, lng: 0};
  icon = {url: './assets/logo-color.svg', scaledSize: {width: 40, height: 40}};
  // hide points of interest, train and buses
  // mapStyles = [
  //   { "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }]},
  //   { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }]},
  //   { "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }]},
  //   { "elementType": "labels.text.stroke", "stylers": [{ "color": "#f5f5f5" }]},
  //   { "featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{ "color": "#bdbdbd" }]},
  //   { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }]},
  //   { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }]},
  //   { "featureType": "poi.business", "stylers": [{ "visibility": "off" }]},
  //   { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }]},
  //   { "featureType": "poi.park", "elementType": "labels.text", "stylers": [{ "visibility": "off" }]},
  //   { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }]},
  //   { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }]},
  //   { "featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{"color": "#757575" }]},
  //   { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#dadada" }]},
  //   { "featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }]},
  //   { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }]},
  //   { "featureType": "transit.line", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }]},
  //   { "featureType": "transit.station", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }]},
  //   { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#c9c9c9" }]},
  //   { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }]}
  // ];

  constructor(private totemService: TotemService ) { }

  ngOnInit() {
    this.getInformacion();
    window.addEventListener('scroll', this.scrollevent, true);
  }

  showPlace(place: any) {
    this.activePlace = place.namekey;
    this.showMarker = false;
    this.selectedPlace = place;
    this.listadoSup = this.informaciones.slice(0, 10);
    this.listadoInf = this.informaciones.slice(10);
    setTimeout(() => {
      this.informaciones = this.informaciones.map((pl) => {
        if (this.lastPlaceClicked) {
          if (pl.name === this.lastPlaceClicked.name) {
            pl.active = false;
          }
        }
        if (pl.name === place.name) {
          pl.active = true;
        }
        return pl;
        });
      this.showMarker = true;
      this.marker.lat = parseFloat(place.lat);
      this.marker.lng = parseFloat(place.lng);
      // animate
      this.center.zoom = place.zoom;
      this.center.lat = parseFloat(place.centerLat);
      this.center.lng = parseFloat(place.centerLng);

      this.lastPlaceClicked = place;
    }, 200);
  }

  async getInformacion() {
    try {
      await this.totemService.getPuntos().toPromise().then((res: any) => {
        this.informaciones = res;
        this.informaciones.filter(info => {
          if(info.id_edificio == environment.edificio) {
            const ix = this.informaciones.indexOf(info);
            // Mueve la informacion del mall actual al principio de la lista
            this.swap(ix, 0);
            this.showPlace(info);
          }
        });
        console.log(this.informaciones);
      });
    } catch (error) {
      console.error(error);
    }
  }

  private swap(x: any, y: any) {
    var b = this.informaciones[x];
    this.informaciones[x] = this.informaciones[y];
    this.informaciones[y] = b;
  }

 // logica de reinicio
 scrollevent = (event: any): void => {
   this.cancelartimer();
}
public cancelartimer() {
 this.totemService.emitirReinicioTotem();
}
}
